// Full-document render of the sealy CustomerContentHubSocialPage: PageSkeleton
// (the React document shell) wrapping the hub header (rendered only when the
// page sits under a CustomerContentHubRootPage, like the legacy partial's
// {% if love_root %}) and the existing social-gallery body island.
import React from "react";

import { templates } from "@reactivated";

import { CustomerContentHubHeader } from "../apps/customer-content-hub/CustomerContentHubHeader";
import { CustomerContentHubSocialPage as CustomerContentHubSocialPageBody } from "../apps/customer-content-hub/CustomerContentHubSocialPage";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.CustomerContentHubSocialPageDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        {props.love_root && (
            <CustomerContentHubHeader love_root={props.love_root} />
        )}
        <CustomerContentHubSocialPageBody
            page_info={props.page_info}
            love_root_info={props.love_root_info}
            initial_ugc_data={props.initial_ugc_data}
            initial_next_url={props.initial_next_url}
        />
    </PageSkeleton>
);
